import { render, staticRenderFns } from "./Ep4.vue?vue&type=template&id=60a89775&scoped=true&"
import script from "./Ep4.vue?vue&type=script&lang=ts&"
export * from "./Ep4.vue?vue&type=script&lang=ts&"
import style0 from "./Ep4.vue?vue&type=style&index=0&id=60a89775&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a89775",
  null
  
)

export default component.exports